import React, {useContext, useEffect} from 'react';
import Home from './pages/home/home';
import {Switch, Route, Redirect} from 'react-router-dom';
import Header from './components/header/header';
import './app.css';
import CheckCookie from './api/user/user.jsx';
import Register from './pages/register/register';
import Login from './pages/Login/login';
import Tasks from './pages/tasks/tasks';
import AddTask from './pages/add task/add_task';
import Profile from './pages/profile/profile';
import { AuthorizationContext } from './context/authorizationContext';
import Secret from './pages/secret/secret';
import About from './pages/about/about';
import Contact from './pages/contact/contact';
import Company from './pages/company/company';

const App = ()=>{

    const { setUserDetail, setFlagLoggedin, setPath } = useContext(AuthorizationContext);

    useEffect(async()=>{
        CheckCookie({}, (response)=>{
            console.log("Printing response comes from API call and printing in App.js", response);
            if(response.data.status){
                console.log("Status is true");
                setFlagLoggedin(true);
                setUserDetail(response.data.data[0]);
                setPath(window.location.pathname)
            }
        }, (error)=>{
            console.log("Printing error comes from API call in App.js", error);
        })
    }, []);

    return (
        <>
            {window.location.pathname === "/onboard/developers/29119723/secret/page/visibility/true" ? null : <Header />}
            <Switch>
                <Route path="/" component={Home} exact={true}></Route>
                <Route path="/login" component={Login} exact={true}></Route>
                <Route path="/profile" component={Profile} exact={true}>
                    <Profile />
                </Route>
                <Route path="/tasks" component={Tasks} exact={true}></Route>
                <Route path="/history" component={Tasks} exact={true}></Route>
                <Route path="/add/task" component={AddTask} exact={true}></Route>
                <Route path="/about" component={About} exact={true}></Route>
                <Route path="/contact" component={Contact} exact={true}></Route>
                <Route path="/company" component={Company} exact={true}></Route>
                <Route path="/onboard/developers/29119723/secret/page/visibility/true" exact={true} component={()=><Secret />}>
                    <Secret />
                </Route>
                <Route path="*" component={()=><Redirect to="/" />}></Route>
            </Switch>
        </>
    )
}

export default App;
